import React from "react"
import { FaChevronDown, FaChevronUp } from "react-icons/fa"
import InfiniteScroll from "react-infinite-scroll-component"
import { useTranslation } from "react-i18next"

import { InfiniteScrollLoader } from "components"
import OrdersTableRow from "./OrdersTableRow"
import classes from "./index.module.scss"

const OrdersTable = props => {
  const {
    skip,
    hasMore,
    loadMore,
    sortBy,
    setSortBy,
    orders,
    setOrders,
    showPaymentFollowUp = false
  } = props

  const [t] = useTranslation()

  const handleClick = () => {
    setSortBy(prev =>
      prev === "oldestOrder" ? "newstOrder" : "oldestOrder"
    )
  }

  return (
    <InfiniteScroll
      hasMore={hasMore}
      dataLength={skip}
      next={loadMore}
      loader={<InfiniteScrollLoader />}
      scrollThreshold="100px"
    >
      <div className={classes["table-container"]}>
        <table className={classes["table"]}>
          <thead className={classes["thead"]}>
            <tr>
              <th>{t("کد_سفارش")}</th>
              <th
                className={classes["click"]}
                onClick={handleClick}
              >
                {t("تاریخ_ایجاد_سفارش")}{" "}
                {sortBy === "newstOrder" ? <FaChevronUp /> : <FaChevronDown />}
              </th>
              <th>{t("نام_مشتری")}</th>
              <th>{t("نوع_پرداخت")}</th>
              <th>{t("وضعیت")}</th>
              <th>{t("طریق_سفارش")}</th>
              <th>{t("نوع_تحویل")}</th>
              <th>{t("شعبه")}</th>
              <th>{t("مبلغ_پرداخت_شده")}</th>
              <th>{t("جزئیات")}</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(order => (
              <OrdersTableRow
                key={order._id}
                order={order}
                setOrders={setOrders}
                showPaymentFollowUp={showPaymentFollowUp}
              />
            ))}
          </tbody>
        </table>
      </div>
    </InfiniteScroll>
  )
}

export default OrdersTable
